import { memo } from "react";
import PageTitle from "../../../../Reuse/UI/PageTitle";

const ReleaseComponent = (props) => {
  return <PageTitle {...props} count={0} />;
};

export default memo(ReleaseComponent);
